import { render, staticRenderFns } from "./TaskListDialog.vue?vue&type=template&id=59b40c01"
import script from "./TaskListDialog.vue?vue&type=script&lang=js"
export * from "./TaskListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports